import { render, staticRenderFns } from "./BulkProjectRelatedPlushies.vue?vue&type=template&id=1deb8afe&scoped=true&"
import script from "./BulkProjectRelatedPlushies.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectRelatedPlushies.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectRelatedPlushies.vue?vue&type=style&index=0&id=1deb8afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb8afe",
  null
  
)

export default component.exports